export const DEFAULT_BASE_COLOR = 'var(--color_neutral_400)'
export const DEFAULT_HIGHLIGHT_COLOR = 'var(--color_neutral_200)'
